type SelectInputOption = {
  label: string;
  value: number | string;
};

type SelectInputProps = {
  label: string;
  className?: string;
  value: number | string;
  options: SelectInputOption[];
  onChange: (_value: string) => void;
};

export function SelectInput({ value, options, onChange }: SelectInputProps) {
  return (
    <div>
      <select
        className="w-full p-0 border-0 text-lg"
        onChange={event => {
          onChange(event.target.value);
        }}
        value={value}
      >
        {options.map(option => {
          return (
            <option key={`select-input-${option.value}-${option.label}`} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
    </div>
  );
}
